import { SvgIcon } from "@mui/material";

export const CircleIcon = ({ sx, ...rest }) => {
  return (
    <SvgIcon viewBox="0 0 6 6" sx={{ height: 6, width: 20, ...sx }} {...rest}>
      <circle cx="3" cy="3" r="3" fill="white" />
    </SvgIcon>
  );
};
